export const DYNAMIC_VALUES = "DYNAMIC_VALUES";
